import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.white};
  border-radius: 8px;
  padding: 1rem;

  > p {
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    color: #000;
    margin: 0;
  }
`;
export const FooterButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 1rem 0 0 0;
  gap: 1rem;
`;

